import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};

export const AllTransferStationTransactions1 = async (
  StartDate,
  endDate,
  VehicleNumber,
  zoneId,
  circleId,
  collectionTypeId,
  ownerTypeId,
  vehicleTypeId,
  transferStationId
) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllTransferStationTransaction?startDate=${StartDate}&endDate=${endDate}&vehicleNumber=${VehicleNumber}&zoneId=${zoneId}&circleId=${circleId}&collectionTypeId=${collectionTypeId}&ownerTypeId=${ownerTypeId}&vehicleTypeId=${vehicleTypeId}&transferStationId=${transferStationId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};


export const AllTransferStationTransactions = async (
  StartDate,
  endDate,
  VehicleNumber,
  zoneId,
  circleId,
  collectionTypeId,
  ownerTypeId,
  VehicleTypeId,
  transferStationId
) => {
  const ownerId = ownerTypeId == null ? '' : ownerTypeId;
  // const loadingId = LoadingEquipmentId === null ? '' : LoadingEquipmentId;
  const vehicleId = VehicleTypeId == null ? '' : VehicleTypeId;
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `RawReport/GetAllTransferStationTransaction?startDate=${StartDate}&endDate=${endDate}&VehicleNumber=${VehicleNumber}&ZoneId=${zoneId?zoneId:""}&CircleId=${circleId}&CollectionTypeId=${collectionTypeId}&OwnerTypeId=${ownerId}&VehicleTypeId=${vehicleId}&TranferStationId=${transferStationId?transferStationId:""}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};





export const AllTransferStationTotalTransactions = async (
  StartDate,
  endDate,
  collectionTypeId,
  ownerTypeId,
  vehicleType,
  transferStationId
) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllTransferStationTransaction?startDate=${StartDate}&endDate=${endDate}&CollectionTypeId=${collectionTypeId}&OwnerTypeId=${ownerTypeId}&VehicleTypeId=${vehicleType}&TranferStationId=${transferStationId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetSCVTripsToTS = async (queryParams) => {
  const queryString = new URLSearchParams(queryParams).toString();
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetTransferStationTripTransactionsDetails?CollectionTypeId=2&${queryString}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
